import { request } from "../api";

// /api/accounting/bank
export const listAccounts = () => request.get("/bank/accounts");
export const createAccount = body => request.post("/bank/accounts", body);
export const updateAccount = (id, body) => request.put(`/bank/accounts/${id}`, body);
export const deactivateAccount = id => request.del(`/bank/accounts/${id}`);
export const importFile = (id, formData) => request.upload(`/bank/accounts/${id}/import`, formData);
export const syncAccount = id => request.post(`/bank/accounts/${id}/sync`);
export const connectAccount = (id, body) => request.post(`/bank/accounts/${id}/connect`, body);

export const listTransactions = params => request.get("/bank/transactions", params);
export const getTransaction = id => request.get(`/bank/transactions/${id}`);
export const matchTransaction = (id, matches) =>
  request.post(`/bank/transactions/${id}/match`, { matches });
export const unmatchTransaction = (id, reason) =>
  request.post(`/bank/transactions/${id}/unmatch`, { reason });
export const ignoreTransaction = (id, note) =>
  request.post(`/bank/transactions/${id}/ignore`, { note });
export const autoMatch = ids => request.post("/bank/transactions/automatch", { ids });
export const searchTargets = params => request.get("/bank/transactions/search", params);

export const reconciliationSummary = () => request.get("/bank/reconciliation/summary");

export const listProposals = () => request.get("/bank/proposals");
export const listBatches = params => request.get("/bank/batches", params);
export const createBatch = body => request.post("/bank/batches", body);
export const createDirectDebit = body => request.post("/bank/batches/direct-debit", body);
export const debitCandidates = () => request.get("/bank/batches/direct-debit/candidates");
export const batchXml = id => request.blob(`/bank/batches/${id}/xml`);
export const markUploaded = id => request.post(`/bank/batches/${id}/uploaded`);
export const cancelBatch = id => request.post(`/bank/batches/${id}/cancel`);
